// external libs
import 'flowbite'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import Lity from 'lity'
import 'lity/dist/lity.min.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

// custom scripts
import MapOperations from './js/MapOperations'

document.addEventListener('DOMContentLoaded', function (e) {
	AOS.init({
		duration: 600,
		once: true,
		offset: 80,
	})
	MapOperations.init()
})
